import React from 'react';

const ModeToggle = ({ mode, onChange, size = 'md' }) => {
  const isAgent = mode === 'agent';
  const trackClass = size === 'sm' ? 'h-5 w-10' : 'h-6 w-12';
  const knobClass =
    size === 'sm'
      ? `h-4 w-4 ${isAgent ? 'translate-x-5' : 'translate-x-0.5'}`
      : `h-5 w-5 ${isAgent ? 'translate-x-6' : 'translate-x-0.5'}`;
  const labelClass = size === 'sm' ? 'text-[10px]' : 'text-xs';

  return (
    <div className="flex items-center gap-2.5">
      <span
        className={`${labelClass} font-bold uppercase tracking-wider transition-colors ${
          !isAgent ? 'text-[#C4AB04]' : 'text-gray-500'
        }`}
      >
        Human
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={isAgent}
        aria-label={isAgent ? 'Switch to human mode' : 'Switch to agent mode'}
        onClick={() => onChange(isAgent ? 'human' : 'agent')}
        className={`relative inline-flex ${trackClass} items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black ${
          isAgent ? 'bg-[#39FF14] focus:ring-[#39FF14]' : 'bg-[#8A7805] focus:ring-[#C4AB04]'
        }`}
      >
        <span
          className={`inline-block transform rounded-full shadow-md transition-transform duration-300 ${knobClass} ${
            isAgent ? 'bg-black' : 'bg-white'
          }`}
        />
      </button>
      <span
        className={`${labelClass} font-bold uppercase tracking-wider transition-colors ${
          isAgent ? 'text-[#39FF14]' : 'text-gray-500'
        }`}
      >
        Agent
      </span>
    </div>
  );
};

export default ModeToggle;
